"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _permission = require("@/utils/permission");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'DrawGeometryMap',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      form: this.value,
      address: '',
      map: null,
      editor: null,
      polygon: null,
      searchService: null,
      serviceAreaRange: [],
      // 存储多个多边形的坐标数组，每个元素是一个多边形的路径数组
      editorMode: 'draw',
      // 编辑器模式：draw-绘制，edit-编辑
      searchResults: [] // 搜索结果
    };
  },
  mounted: function mounted() {
    if (this.form.serviceAreaRange) this.serviceAreaRange = JSON.parse(this.form.serviceAreaRange);
    this.initMap();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 地址搜索功能
    searchAddress: function searchAddress() {
      var _this = this;
      if (!this.address.trim()) {
        this.$message.warning('请输入搜索地址');
        return;
      }
      if (!this.searchService) {
        // 使用备用搜索方案
        this.searchAddressByHTTP();
        return;
      }

      // 显示加载状态
      var loading = this.$loading({
        lock: true,
        text: '搜索中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.searchService.search({
        keyword: this.address,
        page_size: 10,
        page_index: 1
      }).then(function (result) {
        loading.close();
        if (result.data && result.data.length > 0) {
          _this.searchResults = result.data;
          var firstResult = result.data[0];
          var location = firstResult.location;

          // 移动地图中心到搜索结果
          _this.map.setCenter(new window.TMap.LatLng(location.lat, location.lng));
          _this.map.setZoom(15);

          // 添加标记点
          _this.addSearchMarker(location);
          _this.$message.success("\u627E\u5230 ".concat(result.data.length, " \u4E2A\u7ED3\u679C"));
        } else {
          _this.$message.warning('未找到相关地址');
        }
      }).catch(function (error) {
        loading.close();
        console.error('搜索失败：', error);
        _this.$message.error('搜索失败，请重试');
      });
    },
    // 添加搜索标记
    addSearchMarker: function addSearchMarker(location) {
      // 清除之前的搜索标记
      if (this.searchMarker) {
        this.searchMarker.setMap(null);
      }

      // 创建新的标记
      this.searchMarker = new window.TMap.MultiMarker({
        map: this.map,
        styles: {
          searchMarker: new window.TMap.MarkerStyle({
            width: 25,
            height: 35,
            anchor: {
              x: 12,
              y: 35
            },
            src: 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/marker.png'
          })
        }
      });
      this.searchMarker.add({
        id: 'search-result',
        styleId: 'searchMarker',
        position: new window.TMap.LatLng(location.lat, location.lng)
      });
    },
    // 备用HTTP搜索方案
    searchAddressByHTTP: function searchAddressByHTTP() {
      var _this2 = this;
      // 显示加载状态
      var loading = this.$loading({
        lock: true,
        text: '搜索中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      // 使用腾讯地图WebService API进行搜索
      var url = "https://apis.map.qq.com/ws/place/v1/search";
      var params = {
        keyword: this.address,
        boundary: 'region(北京,0)',
        page_size: 10,
        page_index: 1,
        key: '3RZBZ-Q6DKF-WLEJ2-N5KCS-KLJX3-5BFQG' // 这里需要替换为实际的API Key
      };

      // 构建查询字符串
      var queryString = Object.keys(params).map(function (key) {
        return "".concat(key, "=").concat(encodeURIComponent(params[key]));
      }).join('&');
      fetch("".concat(url, "?").concat(queryString)).then(function (response) {
        return response.json();
      }).then(function (data) {
        loading.close();
        if (data.status === 0 && data.data && data.data.length > 0) {
          _this2.searchResults = data.data;
          var firstResult = data.data[0];
          var location = firstResult.location;

          // 移动地图中心到搜索结果
          _this2.map.setCenter(new window.TMap.LatLng(location.lat, location.lng));
          _this2.map.setZoom(15);

          // 添加标记点
          _this2.addSearchMarker(location);
          _this2.$message.success("\u627E\u5230 ".concat(data.data.length, " \u4E2A\u7ED3\u679C"));
        } else {
          _this2.$message.warning('未找到相关地址');
        }
      }).catch(function (error) {
        loading.close();
        console.error('HTTP搜索失败：', error);
        _this2.$message.warning('搜索服务暂不可用，请手动在地图上定位');
      });
    },
    // 初始化搜索服务
    initSearchService: function initSearchService() {
      try {
        // 尝试初始化搜索服务
        if (window.TMap && window.TMap.service && window.TMap.service.SearchService) {
          this.searchService = new window.TMap.service.SearchService({
            pageSize: 10,
            pageIndex: 1
          });
          console.log('搜索服务初始化成功');
        } else if (window.TMap && window.TMap.SearchService) {
          this.searchService = new window.TMap.SearchService({
            pageSize: 10,
            pageIndex: 1
          });
          console.log('搜索服务初始化成功（备用方式）');
        } else {
          console.warn('腾讯地图搜索服务API不可用，将使用HTTP搜索');
          this.searchService = null;
        }
      } catch (error) {
        console.warn('搜索服务初始化失败，将使用HTTP搜索：', error);
        this.searchService = null;
      }
    },
    // 设置编辑器模式
    setEditorMode: function setEditorMode(mode) {
      this.editorMode = mode;
      if (this.editor) {
        if (mode === 'draw') {
          this.editor.setActionMode(window.TMap.tools.constants.EDITOR_ACTION.DRAW);
        } else if (mode === 'edit') {
          this.editor.setActionMode(window.TMap.tools.constants.EDITOR_ACTION.EDIT);
        }
        // 编辑模式下自动定位到多边形区域
        this.centerToExistingPolygons(mode);
      }
    },
    // 根据已有多边形在地图上定位
    centerToExistingPolygons: function centerToExistingPolygons(mode) {
      try {
        if (!this.polygon || !this.polygon.geometries || this.polygon.geometries.length === 0) return;

        // 优先使用第一个多边形进行定位
        var first = this.polygon.geometries[0];
        if (!first || !first.paths || first.paths.length === 0) return;

        // 编辑模式使用更合适的视野，非编辑模式只居中不改变缩放
        if (mode === 'edit') {
          this.fitMapToPolygon(first.paths);
        } else {
          this.centerMapToPolygon(first.paths);
        }
      } catch (e) {
        console.warn('centerToExistingPolygons error:', e);
      }
    },
    // 删除选中的多边形
    deleteSelectedPolygon: function deleteSelectedPolygon() {
      if (this.editor) {
        try {
          this.editor.delete();
          // 更新坐标数据
          this.updateServiceAreaRange();
          this.$message.success('已删除选中的多边形');
        } catch (error) {
          console.error('删除失败：', error);
          this.$message.error('删除失败，请重试');
        }
      }
    },
    // 更新服务区域坐标数据
    updateServiceAreaRange: function updateServiceAreaRange() {
      var _this3 = this;
      if (this.polygon && this.polygon.geometries && this.polygon.geometries.length > 0) {
        // 获取所有多边形的坐标，每个多边形作为一个独立的路径数组
        this.serviceAreaRange = [];
        this.polygon.geometries.forEach(function (geometry) {
          if (geometry.paths && geometry.paths.length > 0) {
            _this3.serviceAreaRange.push(geometry.paths);
          }
        });
      } else {
        this.serviceAreaRange = [];
      }
      console.log('更新后的坐标数据：', this.serviceAreaRange);
    },
    // 确保样式一致性
    ensureConsistentStyle: function ensureConsistentStyle() {
      if (this.polygon && this.polygon.geometries) {
        this.polygon.geometries.forEach(function (geometry) {
          // 强制设置样式为透明蓝色
          try {
            geometry.setStyleId('polygonStyle');
            // 如果setStyleId不可用，尝试直接设置样式
            if (geometry.setStyle) {
              geometry.setStyle(new window.TMap.PolygonStyle({
                color: '#3777FF',
                opacity: 0.3,
                borderColor: '#3777FF',
                borderWidth: 2
              }));
            }
          } catch (error) {
            console.warn('设置样式失败：', error);
          }
        });
      }
    },
    // 保存
    handleSave: function handleSave() {
      // 将多个多边形数据转换为JSON字符串存储
      this.form.serviceAreaRange = JSON.stringify(this.serviceAreaRange);
      this.$emit('input', this.form);
      this.$emit('getServiceAreaRange', this.serviceAreaRange);
      this.editorMode = 'draw';

      // this.$message.success(`已保存 ${this.serviceAreaRange.length} 个多边形区域`);
    },
    // 绘制已有的多边形
    drawExistingPolygon: function drawExistingPolygon(polygon) {
      try {
        // 检查数据结构，支持两种格式：
        // 1. 旧格式：直接是坐标数组 [[lat, lng], [lat, lng], ...]
        // 2. 新格式：多个多边形的数组 [[[lat, lng], [lat, lng], ...], [[lat, lng], [lat, lng], ...]]
        var polygonData = this.serviceAreaRange;

        // 如果是旧格式（直接是坐标数组），转换为新格式
        if (polygonData.length > 0 && polygonData[0].length === 2 && typeof polygonData[0][0] === 'number') {
          polygonData = [polygonData];
        }

        // 绘制每个多边形
        polygonData.forEach(function (polygonPaths, index) {
          if (polygonPaths && polygonPaths.length > 0) {
            // 将坐标数组转换为TMap格式的路径
            var paths = polygonPaths.map(function (coord) {
              return new window.TMap.LatLng(coord.lat || coord[1], coord.lng || coord[0]);
            });

            // 添加多边形到地图
            polygon.add({
              id: "existing-polygon-".concat(index),
              styleId: 'polygonStyle',
              // 使用默认样式
              paths: paths
            });
          }
        });

        // 编辑时自动定位到第一个多边形区域，但不放大
        if (polygonData.length > 0 && polygonData[0].length > 0) {
          var firstPolygonPaths = polygonData[0].map(function (coord) {
            return new window.TMap.LatLng(coord.lat || coord[1], coord.lng || coord[0]);
          });
          this.centerMapToPolygon(firstPolygonPaths);
        }
      } catch (error) {
        console.error('绘制现有多边形失败：', error);
      }
    },
    // 将地图中心定位到多边形，但不改变缩放级别
    centerMapToPolygon: function centerMapToPolygon(paths) {
      if (!paths || paths.length === 0) return;
      try {
        // 计算多边形的中心点
        var totalLat = 0;
        var totalLng = 0;
        paths.forEach(function (point) {
          totalLat += point.lat;
          totalLng += point.lng;
        });
        var centerLat = totalLat / paths.length;
        var centerLng = totalLng / paths.length;

        // 只移动地图中心，不改变缩放级别
        this.map.setCenter(new window.TMap.LatLng(centerLat, centerLng));
        console.log('编辑模式：地图已定位到多边形中心', {
          centerLat: centerLat.toFixed(6),
          centerLng: centerLng.toFixed(6),
          currentZoom: this.map.getZoom()
        });
      } catch (error) {
        console.error('定位地图中心失败：', error);
      }
    },
    // 调整地图视图以适应多边形
    fitMapToPolygon: function fitMapToPolygon(paths) {
      if (!paths || paths.length === 0) return;
      try {
        // 计算多边形的边界
        var minLat = paths[0].lat;
        var maxLat = paths[0].lat;
        var minLng = paths[0].lng;
        var maxLng = paths[0].lng;
        paths.forEach(function (point) {
          minLat = Math.min(minLat, point.lat);
          maxLat = Math.max(maxLat, point.lat);
          minLng = Math.min(minLng, point.lng);
          maxLng = Math.max(maxLng, point.lng);
        });

        // 添加适当的边距缓冲区，让多边形周围有足够的空间
        var padding = Math.max(0.005, (maxLat - minLat + maxLng - minLng) / 4 * 0.3); // 动态边距
        var paddedMinLat = minLat - padding;
        var paddedMaxLat = maxLat + padding;
        var paddedMinLng = minLng - padding;
        var paddedMaxLng = maxLng + padding;

        // 计算中心点
        var centerLat = (paddedMinLat + paddedMaxLat) / 2;
        var centerLng = (paddedMinLng + paddedMaxLng) / 2;

        // 计算合适的缩放级别 - 针对编辑模式优化
        var latDiff = paddedMaxLat - paddedMinLat;
        var lngDiff = paddedMaxLng - paddedMinLng;
        var maxDiff = Math.max(latDiff, lngDiff);
        var zoom = 12; // 编辑模式默认缩放级别
        if (maxDiff > 0.3) zoom = 9; // 很大范围
        else if (maxDiff > 0.15) zoom = 10; // 大范围
        else if (maxDiff > 0.08) zoom = 11; // 中等范围
        else if (maxDiff > 0.04) zoom = 12; // 小范围
        else if (maxDiff > 0.02) zoom = 13; // 较小范围
        else if (maxDiff > 0.01) zoom = 14; // 很小范围
        else zoom = 15; // 极小范围

        // 设置地图中心点和缩放级别
        this.map.setCenter(new window.TMap.LatLng(centerLat, centerLng));
        //  this.map.setZoom(zoom);

        console.log('编辑模式：地图已调整到多边形位置', {
          centerLat: centerLat.toFixed(6),
          centerLng: centerLng.toFixed(6),
          zoom: zoom,
          polygonSize: maxDiff.toFixed(6)
        });
      } catch (error) {
        console.error('调整地图视图失败：', error);
      }
    },
    initMap: function initMap() {
      var _this4 = this;
      // 初始化地图
      this.map = new window.TMap.Map('container', {
        zoom: 7,
        // 设置地图缩放级别，降低默认缩放级别
        center: new window.TMap.LatLng(39.984104, 116.307503) // 设置地图中心点坐标
      });

      // 初始化搜索服务
      this.initSearchService();

      // 初始化几何图形及编辑器
      this.polygon = new window.TMap.MultiPolygon({
        map: this.map
      });
      this.editor = new window.TMap.tools.GeometryEditor({
        // TMap.tools.GeometryEditor 文档地址：https://lbs.qq.com/webApi/javascriptGL/glDoc/glDocEditor
        map: this.map,
        // 编辑器绑定的地图对象
        overlayList: [
        // 可编辑图层 文档地址：https://lbs.qq.com/webApi/javascriptGL/glDoc/glDocEditor#4
        {
          overlay: this.polygon,
          id: 'polygon'
        }],
        actionMode: window.TMap.tools.constants.EDITOR_ACTION.DRAW,
        // 编辑器的工作模式
        activeOverlayId: 'polygon',
        // 激活图层
        selectable: true,
        // 开启点选功能
        snappable: true,
        // 开启吸附
        // 禁用默认的选中样式，使用自定义样式
        selectedStyle: null,
        // 设置编辑时的样式
        editStyle: null
      });

      // 如果有已有的坐标数据，先绘制到地图上
      if (this.serviceAreaRange && this.serviceAreaRange.length > 0) {
        this.drawExistingPolygon(this.polygon);
        // 初次加载时根据当前模式定位
        this.centerToExistingPolygons(this.editorMode);
      }

      // 监听绘制结束事件，获取绘制几何图形
      this.editor.on('draw_complete', function (geometry) {
        var id = geometry.id;
        if (_this4.editor.getActiveOverlay().id === 'polygon') {
          // 获取多边形顶点坐标
          var geo = _this4.polygon.geometries.filter(function (item) {
            return item.id === id;
          });
          if (geo.length > 0) {
            // 将新绘制的多边形添加到数组中,绘制的多边形坐标:geo[0].paths
            _this4.serviceAreaRange.push(geo[0].paths);
            console.log('当前所有多边形：', _this4.serviceAreaRange);
          }
        }
      });

      // 监听编辑事件
      this.editor.on('geometry_changed', function (geometry) {
        if (_this4.editor.getActiveOverlay().id === 'polygon') {
          var geo = _this4.polygon.geometries.filter(function (item) {
            return item.id === geometry.id;
          });
          if (geo.length > 0) {
            // 找到对应的多边形在数组中的索引并更新
            var geometryIndex = _this4.polygon.geometries.findIndex(function (item) {
              return item.id === geometry.id;
            });
            if (geometryIndex !== -1) {
              // 编辑后的多边形坐标： geo[0].paths, 当前所有多边形： this.serviceAreaRange
              _this4.serviceAreaRange[geometryIndex] = geo[0].paths;
              // 编辑过程中也动态保持视图合适
              _this4.centerToExistingPolygons('edit');
            }
          }
        }
      });

      // 监听删除事件 多边形已删除:geometry
      this.editor.on('geometry_removed', function (geometry) {
        _this4.updateServiceAreaRange();
      });
    }
  }
};